'use strict';

angular.module('shiftTraderApp')
  .service('TokenLedgers', ['$http', 'ServerUrls', 'Session', '$q', function ($http, ServerUrls, Session, $q) {

    var getCurrentTokens = function (org_id) {
      var deferred = $q.defer()

      $http.get(ServerUrls.current.railsApi + 'organizations/' + org_id + '/token_ledgers/latest')
        .then(function(response) {
          var result = (response && response.data && response.data.balance) ? response.data.balance : 0
          deferred.resolve(result)
        }, function(response) {
          deferred.reject(response)
        })

      return deferred.promise
    };

    var getPlans = function () {
      var deferred = $q.defer()

      $http.get(ServerUrls.current.railsApi + 'token_ledgers/get_plans')
        .then(function (response) {
          deferred.resolve(response.data)
        }, function (response) {
          deferred.reject(response)
        })

        return deferred.promise;
    }

    var purchaseTokens = function (org_id, plan_id) {
      var deferred = $q.defer()

      var payload = { plan_id: plan_id }
      $http.post(ServerUrls.current.railsApi + 'organizations/' + org_id + '/token_ledgers/buy_plan', payload)
        .then(function (response) {
          deferred.resolve(response)
        }, function (response) {
          deferred.reject(response)
        })

      return deferred.promise
    }

    return {
      getCurrentTokens: getCurrentTokens,
      getPlans: getPlans,
      purchaseTokens: purchaseTokens
    };

  }]);
